import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
/* eslint-disable react-hooks/exhaustive-deps */
import { useManageTable, useSearchParameter } from "hooks";
import { GetListRequestParams } from "libs/api";

import { useGetDeliveryFees } from "../apis";

const useDeliveryFeesList = () => {
  const [defaultSearchValue] = useSearchParameter("initialSearch");

  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable({
    defaultSearchValue
  });

  const requestParams: GetListRequestParams = {
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: debouncedSearch,
    orderBy: sorting[0]?.id,
    order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
  };

  const { deliveryFees, meta, isLoading, refetch } =
    useGetDeliveryFees(requestParams);

  return {
    deliveryFees,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchDeliveryFees: refetch
  };
};

export default useDeliveryFeesList;
